import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { X, Images, FolderOpen, Users, Shield, Settings, FileStack } from 'lucide-react'
import { RootState } from '@/store/store'
import { setMobileMenuOpen } from '@/store/slices/uiSlice'
import { useGetAdminStatusQuery } from '@/store/api'

const navItems = [
  { to: '/library', icon: Images, label: 'Library' },
  { to: '/files', icon: FileStack, label: 'Files' },
  { to: '/albums', icon: FolderOpen, label: 'Albums' },
  { to: '/faces', icon: Users, label: 'Faces' },
  { to: '/admin', icon: Shield, label: 'Admin' },
  { to: '/settings', icon: Settings, label: 'Settings' },
]

function MobileNav() {
  const dispatch = useDispatch()
  const mobileMenuOpen = useSelector((state: RootState) => state.ui.mobileMenuOpen)

  if (!mobileMenuOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={() => dispatch(setMobileMenuOpen(false))}
      />

      {/* Menu Panel */}
      <div className="absolute left-0 top-0 bottom-0 w-64 bg-card border-r border-border">
        {/* Header */}
        <div className="p-4 border-b border-border flex items-center justify-between">
          <h1 className="text-xl font-bold text-primary">PIXSIFT</h1>
          <button
            onClick={() => dispatch(setMobileMenuOpen(false))}
            className="p-2 hover:bg-secondary rounded-md"
          >
            <X size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-2">
          <ul className="space-y-1">
            {navItems.map(({ to, icon: Icon, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  onClick={() => dispatch(setMobileMenuOpen(false))}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-3 rounded-md transition-colors ${
                      isActive
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                    }`
                  }
                >
                  <Icon size={20} />
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Service Status */}
        <MobileServiceStatus />
      </div>
    </div>
  )
}

function MobileServiceStatus() {
  const { data: status } = useGetAdminStatusQuery(undefined, { pollingInterval: 30000 })
  const total = status?.services.length ?? 0
  const running = status?.services.filter(s => s.status === 'running').length ?? 0

  return (
    <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-border">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span className={`status-dot ${
          running === 0 ? 'status-stopped' : running === total ? 'status-running' : 'status-starting'
        }`} />
        <span>Services: {running}/{total} Online</span>
      </div>
    </div>
  )
}

export default MobileNav
